import utility from './utility'
import doctype from './doctype'

function setViewBox (obj, viewBox) {
  for (let key in obj) {
    if (obj.hasOwnProperty(key) && key !== 'viewBox') {
      obj[key].viewBox = viewBox
    }
  }

  return obj
}

export default {
  xmlns: 'http://www.w3.org/2000/svg',
  ...setViewBox(utility, utility.viewBox),
  ...setViewBox(doctype, doctype.viewBox),
}
